import React, {
  FunctionComponent,
  useState,
  useContext,
  FormEvent,
} from "react";
import styles from "./Reply.module.scss";
import CardUser from "shared/components/CardUser/CardUser";

import Collapse from "@material-ui/core/Collapse";
import MUButton from "@material-ui/core/Button";

import AppContext from "context/AppContext";
import ReactMarkdown from "react-markdown";
import CodeBlock from "shared/components/CodeBlock/CodeBlock";
import moment from "moment";
import Button from "shared/components/Buttons/Button";
import apiCalls from "shared/utils/apiCalls";
import Input from "shared/components/Input/Input";

const ReplyCard: FunctionComponent<{ reply: any; getFeedbacks?: any }> = ({
  reply,
  getFeedbacks,
}) => {
  const [editting, setEditting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updatedContent, setUpdatedContent] = useState<any>(reply.content);
  const { state, dispatch } = useContext(AppContext);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const submit = async () => {
      setLoading(true);
      const res = await apiCalls(
        {
          method: "put",
          data: { content: updatedContent },
          url: `/reply/${reply.id}`,
        },
        dispatch
      );

      if (res) {
        await getFeedbacks();
      }

      setLoading(false);

      setEditting(false);
    };

    submit();
  };

  return (
    <>
      <div className={styles.reply}>
        <CardUser detailsHidden user={reply?.user} small />

        {!editting && (
          <div className={styles.reply_contentWrapper}>
            <div className={styles.reply_content_topContent}>
              <div className={styles.reply_content_userName}>
                {reply.user.name}{" "}
                {reply.user.role === "admin" && (
                  <span className={styles.reply_content_userName_admin}>
                    admin
                  </span>
                )}
              </div>

              {state.user?.uid === reply.uid && (
                <MUButton
                  variant="text"
                  type="button"
                  style={{
                    textTransform: "lowercase",
                    fontFamily: "var(--heading-font-family)",
                    color: "var(--blue-light)",
                    fontSize: "var(--text-2xs)",
                  }}
                  size="small"
                  onClick={() => setEditting(true)}
                >
                  edit
                </MUButton>
              )}
            </div>

            <div className={styles.reply_content}>
              {reply?.content && (
                <ReactMarkdown
                  renderers={{ code: CodeBlock }}
                  source={reply?.content}
                ></ReactMarkdown>
              )}
            </div>
          </div>
        )}

        {state.user && editting && (
          <form onSubmit={onSubmit} style={{ width: "100%" }}>
            <Input
              value={updatedContent}
              onChange={(e: any) => setUpdatedContent(e.target.value)}
              name="reply"
              label="Reply"
              variant="outlined"
              fullWidth
              rows="3"
              multiline
            />

            <Collapse in={!!reply}>
              <div className={styles.reply_buttons}>
                <Button
                  aria-label="cancel"
                  loading={loading}
                  type="button"
                  buttonVariant="default"
                  size="small"
                  style={{
                    marginRight: "var(--space-xs)",
                  }}
                  onClick={() => {
                    setEditting(false);
                    setUpdatedContent(reply.content);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  aria-label="update"
                  type="submit"
                  size="small"
                  loading={loading}
                  disabled={reply.content === updatedContent}
                >
                  Update
                </Button>
              </div>
            </Collapse>
          </form>
        )}
      </div>

      <div className={styles.reply_submittedTime}>
        {moment(reply?.submittedAt).toNow()}
      </div>
    </>
  );
};

export default ReplyCard;
